import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  Selectors,
  Async,
  Actions,
} from 'modules/Dashboard/Widgets/WidgetsSlice';

export const useStudentsProgress = () => {
  const { studentsProgress, studentsProgressTests, users } = useSelector(
    Selectors.fetchListData
  );

  const dispatch = useDispatch();

  useEffect(() => {
    return () => dispatch(Actions.cancelRequests());
  }, [dispatch]);

  const fetchStudentsProgress = useCallback(
    ({ studentId, testId, startDate, endDate, days }) => {
      const params = {
        student_id: studentId,
        test_id: testId,
      };

      // Only send days when start_date and end_date are not provided
      if (startDate && endDate) {
        params.start_date = startDate;
        params.end_date = endDate;
      } else if (days) {
        params.days = days;
      }

      dispatch(Async.fetchStudentsProgress(params));
    },
    [dispatch]
  );

  const fetchStudentsList = useCallback(
    (searchTerm) => {
      dispatch(Async.fetchStudentsList({ search: searchTerm }));
    },
    [dispatch]
  );

  const fetchStudentsProgressTests = useCallback(() => {
    dispatch(Async.fetchStudentsProgressTests());
  }, [dispatch]);

  const clearStudentsProgress = useCallback(() => {
    dispatch(Async.clearStudentsProgressData());
  }, [dispatch]);

  return {
    fetchStudentsProgress,
    fetchStudentsList,
    fetchStudentsProgressTests,
    clearStudentsProgress,
    studentsProgress,
    studentsProgressTests,
    students: users,
  };
};
